import config from "./config";

let shapes;

function initShapes() {
    shapes = {
        arrow: new THREE.Mesh(
            new THREE.ConeGeometry(1, 1, 16),
            new THREE.MeshPhongMaterial({
                color: config.arrow.color,
                transparent: true,
                opacity: wv.annotationArrowOpacity
            })
        ),

        cylinder: new THREE.Mesh(
            new THREE.CylinderGeometry(1, 1, 1, 16),
            new THREE.MeshPhongMaterial({
                color: config.cylinder.color,
                transparent: true,
                opacity: wv.annotationArrowOpacity
            })
        )
    };
}

export default function AnnotationView(id, color) {
    if (!shapes) initShapes();

    this.borderColor = color.border;

    this.arrow = shapes.arrow.clone();
    this.arrow.rotation.x = Math.PI;
    this.line = shapes.cylinder.clone();
    this.line.material = this.line.material.clone();
    this.line.material.color = new THREE.Color(color.line);

    this.object = new THREE.Object3D();
    this.object.annotationId = id;
    this.object.add(this.arrow);
    this.object.add(this.line);

    this.tooltip = new TooltipControl(this.object);
    this.tooltip.getTooltipObject().name = TooltipTypeEnum.ANNOTATION;
    this.setTooltipVisibility(true);
}

AnnotationView.prototype = {
    dispose: function () {
        removeThisTooltip(this.tooltip);
        disposeObject(this.object);
    },

    setText: function (text) {
        this.tooltip.setText(text, {
            fontface: global_font_family,
            borderColor: this.borderColor
        });
    },

    setTooltipVisibility: function(isVisible) {
        this.tooltip.show(isVisible);
    },

    setTooltipOrientation: function(lookAt) {
        this.tooltip.updateLookAt(lookAt);
    },

    resize: function ({arrowPositionY, arrowScale, linePositionY, lineScale, tooltipPositionY}) {
        this.arrow.position.setY(arrowPositionY);
        this.arrow.scale.copy(arrowScale);
        this.line.position.setY(linePositionY);
        this.line.scale.copy(lineScale);
        this.tooltip.setPosition(new THREE.Vector3(0, tooltipPositionY, 0));
    },

    setConfiguration: function (configuration) {
        this.object.position.copy(configuration.position);
        this.object.quaternion.copy(configuration.orientation);
    },

    setVisibility: function (isVisible) {
        this.object.visible = isVisible;
    },

    setDetails: function (data) {
        let text = "";
        if (data.isDetailsShown) {
            let position = data.config.position;
            const node = MeshHierarchyViewFeatureData.getDataFromBranchID(data.location.branchId);
            text = `Author: ${data.info.authorName}\n${data.info.text}\n${node ? node.name : data.location.branchId}\n` +
                `X: ${position.x.toFixed(3)} Y: ${position.y.toFixed(3)} Z: ${position.z.toFixed(3)}\n`
        } else {
            text = data.info.text;
        }

        this.setText(text);
    },

    setSeeThrough: function (seeThrough) {
        traverserMeshObject(this.object);

        function traverserMeshObject(object) {
            if (object.hasOwnProperty('children')) {
                object.children.forEach(child => {
                    traverserMeshObject(child);
                })
            }

            if (object.isMesh) {
                object.material.depthTest = !seeThrough;
                if (object.material.map) {
                    object.material.map.needsUpdate = true;
                }
            }
        }
    }
};

AnnotationView.prototype.constructor = AnnotationView;
